import React from "react";
import { useTranslation } from "react-i18next";
import ButtonLink from "../ButtonLink";
import Copy from "../Copy";
import { Main, Wrapper } from "../Layout";
import SubHeading from "../SubHeading";
import { TextDivider } from "../Divider";
import Title from "../Title";

const CreateJoin: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Main>
        <Copy>
          <Title>{t("createJoin.title", "Create and join leagues")}</Title>
          <SubHeading>
            {t("createJoin.joinLeague.title", "Join a League")}
          </SubHeading>
          <p>
            {t(
              "createJoin.joinLeague.p1",
              "Join a private or public league to compete against friends and other game players.",
            )}
          </p>
          <ButtonLink to="../leagues/join" variant="primary">
            {t("createJoin.joinLeague.button", "Join a league")}
          </ButtonLink>
          <TextDivider>{t("createJoin.or", "or")}</TextDivider>
          <SubHeading>
            {t("createJoin.createLeague.title", "Create a new league")}
          </SubHeading>
          <p>
            {t(
              "createJoin.createLeague.p1",
              "Create a private league to compete against friends.",
            )}
          </p>
          <ButtonLink to="../leagues/create/classic" variant="primary">
            {t("createJoin.createLeague.button", "Create a league")}
          </ButtonLink>
        </Copy>
      </Main>
    </Wrapper>
  );
};

export default CreateJoin;
